<a class="link" [ngClass]="theme">{{ value }}</a>
